/**
 * Outreach Sender Accounts API.
 */
import api from '../../../api';
import type { SenderAccountListResponse, SenderAccount, SenderAccountUpdateFooter, SenderAccountUpdateDailyLimit } from '../types';

const PREFIX = '/api/outreach/sender-accounts';

export const outreachSenderAccountsApi = {
  list: async (): Promise<SenderAccountListResponse> => {
    const { data } = await api.get<SenderAccountListResponse>(PREFIX);
    return data;
  },

  updateFooter: async (accountId: string, payload: SenderAccountUpdateFooter): Promise<SenderAccount> => {
    const { data } = await api.patch<SenderAccount>(`${PREFIX}/${accountId}/footer`, payload);
    return data;
  },

  updateDailyLimit: async (accountId: string, payload: SenderAccountUpdateDailyLimit): Promise<SenderAccount> => {
    const { data } = await api.patch<SenderAccount>(`${PREFIX}/${accountId}/daily-limit`, payload);
    return data;
  },
};
